var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseDeformer } from "../base/BaseDeformer";
var TextGraphicDeformer = /** @class */ (function (_super) {
    __extends(TextGraphicDeformer, _super);
    function TextGraphicDeformer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TextGraphicDeformer.prototype, "transformType", {
        get: function () {
            return this.parent.graphicType;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Ensures the number of values is correct based on the property type. This should be called in each setter.
     */
    TextGraphicDeformer.prototype._validateData = function (value, coordinateCount) {
        if (coordinateCount === void 0) { coordinateCount = 2; }
        var expectedLength = this.parent.graphicCount * coordinateCount;
        if (value.length !== expectedLength) {
            throw Error("Invalid number of values, expected ".concat(expectedLength, " but got ").concat(value.length));
        }
    };
    return TextGraphicDeformer;
}(BaseDeformer));
export { TextGraphicDeformer };
